export const DOB_MIN_YEAR: number = 1950;
export const DOB_MIN_MONTH: number = 1;
export const DOB_MIN_DATE: number = 1;
export const MAX_DOB_MONTH: number = 12;
